export default __webpack_public_path__ + "static/media/html.71ecdad2.svg";